import React, { Component, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import * as API from "../../core/service/api.js";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import {
  removeCompany,
  setCompany,
} from "../../core/feature/company/companySlice";
import logo from "../../assets/images/logo-default.svg";
import logoWhite from "../../assets/images/logo-white.svg";
import logoCompany from "../../assets/images/logo-company.svg";
import ellipse1 from "../../assets/images/icon_login/ellipse1.svg";
import ellipse2 from "../../assets/images/icon_login/ellipse2.svg";
import ellipse3 from "../../assets/images/icon_login/Ellipse3.svg";
import ellipse4 from "../../assets/images/icon_login/Ellipse4.svg";
import intro from "../../assets/images/icon_login/intro-confirm-data.svg";

import Company from "../../core/models/company.js";
import { setLoading } from "../../core/feature/config/configSlice";
import { setToken } from "../../core/feature/token/tokenSlice";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import User from "../../core/models/user.js";
import { removeUser, setUser } from "../../core/feature/user/userSlice";
import fingerPrint from "@fingerprintjs/fingerprintjs";
import Token from "../../core/models/token.js";
import { findIndex } from "lodash";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { createPassword } from "../../core/service/api_profile.js";
import { toast } from "react-toastify";
import eye from "../../assets/images/icon_login/eye.svg";
import eyeclose from "../../assets/images/icon_login/eyeclose.svg";
import { getUser } from "../../core/service/api_card.js";
import {
  removeBalance,
  setBalance,
} from "../../core/feature/user/balanceSlice";
import { t } from "i18next";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { setLastService } from "../../core/feature/lastService/lastServiceSlice";
import { getBalance } from "../../core/service/api_balance";
import { setCustomApp } from "../../core/feature/company/customAppsSlice";
import CustomApp from "../../core/models/customApp";

const ConfirmationDataIntroWeb = () => {
  const { t } = useTranslation();
  const language: String = useAppSelector((state) => state.language.language);

  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const location: any = useLocation();
  const [email, setEmail] = useState("");
  const [resLogin, setResLogin] = useState<any>({});
  const [credential, setCredential] = useState<any>({});
  const [phone, setPhone] = useState("");
  const [typePassword, setTypePassword] = useState("password");
  const [typePassword2, setTypePassword2] = useState("password");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  var CryptoJS = require("crypto-js");

  useEffect(() => {
    setCredential(location.state.credential);
    setEmail(location.state.email);
    setPhone(location.state.phone);
  }, []);

  const createPassword = async () => {
    navigate("/create-password", {
      replace: true,
      state: {
        username: credential?.username,
        email: email,
        phone: phone,
      },
    });
  };
  const skip = async () => {
    dispatch(setLoading(true));
    API.login(credential)
      .then((res) => {
        dispatch(setLoading(false));
        dispatch(setLastService(res.data.user.lastService));
        dispatch(setToken(res.headers.authorization.replaceAll("Bearer ", "")));
        API.credentialCheck().then((resCredential) => {
          if (resCredential.data.user.accounts[0].roles.includes("ROLE_USER")) {
            var auto = "1";
            var ciphertext = CryptoJS.AES.encrypt(
              JSON.stringify(credential),
              "credential"
            ).toString();
            localStorage.setItem("credential", ciphertext);
            localStorage.setItem("auto_login", auto);
            dispatch(setUser(resCredential.data.user));
            getBalance().then((balance) => {
              dispatch(setBalance(balance.data.balance));

              if (res.data.user.lastService == "KATALIS") {
                var languageUpper = language.toUpperCase();
                API.getCustomApps(
                  resCredential.data.activeCompany.id,
                  languageUpper
                ).then((resCustom: any) => {
                  console.log(resCustom.data);
                  dispatch(setCustomApp(resCustom.data));
                  navigate("/home", { replace: true });
                });
              } else {
                dispatch(removeUser());
                dispatch(removeBalance());
                dispatch(removeCompany());
                toast.error(t("LOGIN.accessInvalid"));
                navigate("/login", { replace: true });
              }
            });
          } else {
            return toast.error(t("LOGIN.accessInvalid"));
          }
        });
      })
      .catch((err) => {
        dispatch(setLoading(false));
        // toast.error(t("LOGIN.wrongLogin"));
      });
  };
  return (
    <>
      <div className="relative font-montserrat p-0 m-0 bg-psp-primary">
        <div className="flex min-h-screen">
          <div className="w-1/3 sm:w-1/2 md:w-1/3 flex-0 bg-psp-login relative">
            <img
              src={ellipse1}
              className="absolute bottom-0 left-0 z-0 select-none"
            />
            <img
              src={ellipse2}
              className="absolute top-0 left-0 z-0 select-none"
            />

            <div className="mt-48 sm:mt-36 md:mt-48 flex flex-col items-start z-10 p-10 gap-8">
              <img src={logoWhite} className="z-10 h-14 select-none" />
              <p className="text-white z-10 mt-6 text-xs font-light">
                {t("LOGIN.description")}
              </p>
            </div>
          </div>
          <div className="flex w-full p-16 bg-psp-primary relative">
            <div className="px-4 pb-0 pt-12 z-10 w-full">
              <h1 className="text-gray-400 text-2xl font-medium select-none">
                Welcome To
              </h1>
              <p className="text-black font-semibold text-4xl select-none">
                PSP Web Dekstop
              </p>
              <div className="mt-10 flex flex-col items-center">
                <LazyLoadImage
                  effect="blur"
                  src={intro}
                  alt=""
                  className="h-[345px]"
                />
                <p className="font-medium text-sm text-[#B9B9B9] text-center">
                  {t("CONFIRMATIONDATA.description")}
                </p>
                <div className="flex flex-row gap-3 w-1/2">
                  <button
                    onClick={() => createPassword()}
                    className=" px-4 bg-[#0054E6] text-[#EAEAEA] font-bold text-sm items-center justify-center  w-full flex flex-row rounded-lg gap-3 py-2.5 active:bg-psp-active"
                  >
                    {t("CONFIRMATIONDATA.changePassword")}
                  </button>
                  <button
                    onClick={() => skip()}
                    className="px-4 bg-transparent border-[0.5px] border-solid border-[#0054E6] text-[#0054E6] font-bold text-sm items-center justify-center  w-full flex flex-row rounded-lg gap-3 py-2.5 active:bg-psp-active"
                  >
                    {t("CONFIRMATIONDATA.skip")}
                  </button>
                </div>
              </div>
            </div>
            <img src={ellipse3} className="absolute top-0 -left-72 -z-0" />
            <img src={ellipse4} className="absolute bottom-0 right-0 -z-0" />
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmationDataIntroWeb;
